function initTooltips() {
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
}

function initPopovers() {
  const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
  const popoverList = [...popoverTriggerList].map(function (popoverTriggerEl) {
    new bootstrap.Popover(popoverTriggerEl, {
      html: true,
      container: 'body'
    });

    popoverTriggerEl.addEventListener('click', function (e) {
      e.preventDefault()
    });
  });
}

document.addEventListener('turbo:load', function () {
  initTooltips();
  initPopovers();
});

document.addEventListener('popovers:init', function () {
  initPopovers();
});
